export default __webpack_public_path__ + "static/media/caf.58772920.png";